// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Blob, BlobT, verifyBlob } from "./blob";

/**
 * One source file of an IDL bundle.
 */
export class IdlSourceFile implements flatbuffers.IUnpackableObject<IdlSourceFileT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IdlSourceFile {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIdlSourceFile(bb: flatbuffers.ByteBuffer, obj?: IdlSourceFile): IdlSourceFile {
    return (obj || new IdlSourceFile()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIdlSourceFile(
    bb: flatbuffers.ByteBuffer,
    obj?: IdlSourceFile,
  ): IdlSourceFile {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IdlSourceFile()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  content(obj?: Blob): Blob | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Blob()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * True for an include the converter supplied from its built-in set.
   */
  builtin(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startIdlSourceFile(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addContent(builder: flatbuffers.Builder, contentOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, contentOffset, 0);
  }

  static addBuiltin(builder: flatbuffers.Builder, builtin: boolean) {
    builder.addFieldInt8(2, +builtin, +false);
  }

  static endIdlSourceFile(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // name
    builder.requiredField(offset, 6); // content
    return offset;
  }

  unpack(): IdlSourceFileT {
    return new IdlSourceFileT(
      this.name(),
      this.content() !== null ? this.content()!.unpack() : null,
      this.builtin(),
    );
  }

  unpackTo(_o: IdlSourceFileT): void {
    _o.name = this.name();
    _o.content = this.content() !== null ? this.content()!.unpack() : null;
    _o.builtin = this.builtin();
  }

  unpackFields(...fields: string[]): IdlSourceFileT {
    const t = new IdlSourceFileT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("content")) {
      t.content = this.content() !== null ? this.content()!.unpack() : null;
    }
    if (fieldSet.has("builtin")) {
      t.builtin = this.builtin();
    }
    return t;
  }
}

export class IdlSourceFileT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public content: BlobT | null = null,
    public builtin: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    if (this.content === null || this.content === undefined) {
      throw new Error('Required field "content" is not set');
    }
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const content = this.content !== null ? this.content!.pack(builder) : 0;

    IdlSourceFile.startIdlSourceFile(builder);
    IdlSourceFile.addName(builder, name);
    IdlSourceFile.addContent(builder, content);
    IdlSourceFile.addBuiltin(builder, this.builtin);

    return IdlSourceFile.endIdlSourceFile(builder);
  }

  clone(): IdlSourceFileT {
    const obj = new IdlSourceFileT();
    obj.name = this.name;
    obj.content = this.content !== null ? this.content!.clone() : null;
    obj.builtin = this.builtin;
    return obj;
  }

  equals(other: IdlSourceFileT): boolean {
    if (this.name !== other.name) return false;
    if (this.content !== null && other.content !== null) {
      if (!this.content!.equals(other.content!)) return false;
    } else if (this.content !== other.content) return false;
    if (this.builtin !== other.builtin) return false;
    return true;
  }
}

export function verifyIdlSourceFile(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "name");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyBlob(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "content");
    verifier.checkScalarField(tablePos, 8, 1);
  } finally {
    verifier.popDepth();
  }
}
